__turbopack_context__.v({
  "icon": "_9ALJxW_icon",
  "listItem": "_9ALJxW_listItem",
});
